import { SET_CONTAINER_BULK } from "constants-lib/actionTypes"

/**
 * Action creator for setting the bulk repair data for containers.
 * @param {Object} bulkRepair - The bulk repair data to be set.
 * @returns {Function} A thunk function that takes dispatch as an argument and dispatches the action.
 */
export const setContainerBulk = (bulkRepair) => (dispatch) => {
  dispatch({
    type: SET_CONTAINER_BULK,
    payload: bulkRepair,
  })
}
